/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import {
  generatePath,
  createSearchParams
} from 'react-router-dom';
import _ from 'lodash';
import { type RegistrationRouteParams, registrationRoutes, type RegistrationRouteName, registerRoutes, type RegisterRouteParams } from '@/registration/pages';

// Need to extend the type here so that when reading params back via useParam, we can use proper generic types for each of the pages here.
export interface RouteParams extends RegistrationRouteParams {}

type RouteName = RegistrationRouteName;

// Merging routes here will trigger error "Cannot access 'accountRoutes' before initialization" since routeObjects are only accessible inside the page provider.
// const routes = {...accountRoutes, ...registrationRoutes};
// Instead, we will need to merge routes inside a function.
const getRoutePath = (routeName: RouteName): string => {
  if (registerRoutes[routeName as keyof RegisterRouteParams]) {
    return `/event/:tenantCode/register/${registerRoutes[routeName as keyof RegisterRouteParams].path}`;
  }
  if (registrationRoutes[routeName as RegistrationRouteName]) {
    return `/event/:tenantCode/${registrationRoutes[routeName as RegistrationRouteName].path}`;
  }
  return '';
};

// The generic tyupe PageRouteName here is to avoid a union type of all the params from RouteParams[RouteName].
export function generatePageUrl<PageRouteName extends RouteName>(...args: [
  page: PageRouteName,
  params?: RouteParams[PageRouteName],
  query?: {},
]): string {
  const [page, params = undefined, query = {}] = args;
  const _url = generatePath(getRoutePath(page), params);
  if (_.isEmpty(query)) return _url;

  return `${_url}?${createSearchParams(query).toString()}`;
}
